(() => {
  const translateCheckoutButtons = (root = document) => {
    root.querySelectorAll?.('shopify-buy-it-now-button button').forEach((button) => {
      if (button.textContent.trim() === 'Jetzt zum Checkout') {
        button.textContent = 'Jetzt zur Kasse';
      }
    });
  };

  const start = () => {
    translateCheckoutButtons();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          translateCheckoutButtons(node);
          if (node.matches?.('shopify-buy-it-now-button, shopify-accelerated-checkout')) {
            translateCheckoutButtons(node.parentElement || document);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
